import { Component, OnInit } from '@angular/core';
import { MiraieService } from '../Services/miraie.service';
import { AnalysisService } from '../Services/analysis.service';
import { AuthService } from '../Services/auth.service';
import { OutputService } from '../Services/output.service';
import { DivisionService } from '../Services/division.service';
import { FormService } from "../Services/form.service";
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: ['./contract-list.component.css']
})
export class ContractListComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;
  objectKeys = Object.keys;

  divisions: any;
  division_code: number;
  years: number[];
  quarters: number[] = [1, 2, 3, 4];
  year: number;
  quarter: number;

  result_list;
  user_list;
  quarter_alllist;
  quarter_list;

  srcurl: string;

  constructor(
    private miraieService: MiraieService,
    private analysisService: AnalysisService,
    public authService: AuthService,
    private outputService: OutputService,
    private fs: FormService,
    private ds: DivisionService,
  ) {
    this.ds.getDivisionList().subscribe(res => this.divisions = res);
    this.years = this.fs.formSetYear2(2018);
  }

  ngOnInit() {
    this.srcurl = this.miraieService.srcurl;

    this.division_code = this.authService.getDivisionCode();
    this.year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    if (month < 7) {
      this.year--;
    }
    if (7 <= month && month <= 9) { this.quarter = 1 }
    else if (10 <= month && month <= 12) { this.quarter = 2 }
    else if (1 <= month && month <= 3) { this.quarter = 3 }
    else if (4 <= month && month <= 6) { this.quarter = 4 }

    this.changeQuarter();
  }

  //年度、四半期変更
  changeQuarter() {
    //console.log(this.divisions);
    this.analysisService.getContractList(this.year, this.quarter, this.division_code).subscribe(result => {
      this.quarter_alllist = result['quarter_all'];
      this.quarter_list = result['quarter_divi'];
      this.result_list = result['trigger'];
      this.user_list = result['users'];
    });
  }

  profit(money) {
    var rieki = money * 0.3;
    //rieki = Math.floor(rieki * 100) / 100;
    return rieki;
  }

  //Excel出力
  output() {
    var division_name = "";
    if (this.division_code) {
      var this_dc = this.division_code;
      this.divisions.forEach(function (value) {
        if (value['division_code'] === this_dc) {
          division_name = value['division_name'];
        }
      });
    }

    let res = this.outputService.contract(this.year, this.quarter, division_name, this.quarter_alllist, this.quarter_list, this.result_list, this.user_list)
    res.subscribe(res => {
      //console.log( res );
      const url = this.srcurl + "output/contract/契約進捗一覧_" + this.year + "-" + this.quarter + ".xlsx";
      window.open(url);
    });
  }
  floor(val) {
    return Math.floor(val * 10) / 10;
  }
}
